import { GetRequest, PostRequestFile, PostRequest } from '../lib/request';

const POST_FILE_PATH = `/my-account/my-support/api/upload`;
const GET_CASES_OF_CUSTOMER_PATH=`/my-account/my-support/api/getcasesofcustomer`
const GET_CASE_SETTINGS_PATH = `/my-account/my-support/api/getcasesettings`
const GET_CASE_DETAIL_PATH=`/my-account/my-support/api/getcasedetail`
const ADD_REPLY_TO_CASE_PATH='/my-account/my-support/api/addreplytocase'
const ADD_NEW_CASE_PATH = '/my-account/my-support/api/addnewcase'
const UPDATE_CASE_ACTION_PATH = '/my-account/my-support/api/caseaction'

export async function UploadFile(data){

    try{
        return await PostRequestFile(POST_FILE_PATH,data);
    }catch(ex){
        throw new Error("Remote server unable to upload file.");
    }
    
}

export async function GetCasesOfCustomer(){
    try{
        return await GetRequest(`${GET_CASES_OF_CUSTOMER_PATH}`);
    }catch(ex){
        throw new Error("Remote server unable to fetch cases");
    }
}

export async function GetCaseSettings(){
    try{
        return await GetRequest(`${GET_CASE_SETTINGS_PATH}`);
    }catch(ex){
        throw new Error("Remote server unable to fetch settings");
    }
}

export async function GetCaseDetail(caseid){
    try{
        return await GetRequest(`${GET_CASE_DETAIL_PATH}/${caseid}`);
    }catch(ex){
        throw new Error("Remote server unable to fetch case");
    }
}

export async function AddReplyToCase(data){
    try{
        return await PostRequest(`${ADD_REPLY_TO_CASE_PATH}`, data);
    }catch(ex){
        console.log(ex);
        throw new Error("Remote server unable to add reply to case");
    }
}

export async function UpdateCaseAction(data){
    try{
        return await PostRequest(`${UPDATE_CASE_ACTION_PATH}/close`, data);
    }catch(ex){
        console.log(ex);
        throw new Error("Remote server unable to add reply to case");
    }
}

export async function AddNewCase(data){
    try{
        return await PostRequest(`${ADD_NEW_CASE_PATH}`, data);
    }catch(ex){
        console.log(ex);
        throw new Error("Remote server unable to add case");
    }
}